import React from 'react';
import Img from 'react-image';
import { Flex, Typography, Box, Card, CardTitle, CardContent, color } from '@kistech/kis-ui';
import NoImagePreview from 'assets/no_image_preview.png';

interface ImagePreviewProps {
  previewUrl: string;
  activeImage: string | null;
  imageType?: string;
}
export const ImagePreview: React.FC<ImagePreviewProps> = (props: ImagePreviewProps) => {
  const { previewUrl, activeImage, imageType } = props;

  return (
    <Box margin="0 3" width={325}>
      <Card raised hasBorderRadius>
        <CardTitle
          title={
            <Typography size={18} weight={600}>
              Image Preview
            </Typography>
          }
          gutter={5}
        />
        <CardContent>
          <Flex padding="2" align="center" justify="center">
            {['event', 'genre', 'venue'].includes(imageType || '') ? (
              <Flex width={200} height={150} align="center" justify="center">
                <Img
                  src={previewUrl}
                  width="100%"
                  height="100%"
                  unloader={
                    <img
                      src={NoImagePreview}
                      alt="Loading"
                      width={180}
                      height={158}
                      style={{ objectFit: 'scale-down' }}
                    />
                  }
                  style={{ objectFit: 'cover' }}
                />
              </Flex>
            ) : (
              <Flex width={230} height={252} align="center" justify="center">
                <Img
                  src={previewUrl}
                  width="100%"
                  height="100%"
                  unloader={
                    <img
                      src={NoImagePreview}
                      alt="Loading"
                      width={180}
                      height={158}
                      style={{ objectFit: 'scale-down' }}
                    />
                  }
                  style={{ objectFit: 'scale-down' }}
                />
              </Flex>
            )}
          </Flex>
        </CardContent>
        {activeImage ? (
          <CardContent gutter={5}>
            <Flex fullWidth style={{ borderTop: `1px solid ${color.X_LIGHT_GRAY}` }}>
              <Box width={225}>
                <Typography size={18}>File Details</Typography>
                <Typography>Name: {activeImage}</Typography>
              </Box>
            </Flex>
          </CardContent>
        ) : null}
      </Card>
    </Box>
  );
};
